import React, { useEffect, useState } from "react";
import UserPageSection from "./Content";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import { stakeAContractAddress, stakeAContractABI, bnbDeod, bnbDeodABI } from "../Abi/Content";
import axios from "axios";
import { BigNumber } from "bignumber.js";
import { claimRewards } from "../../../api/endpoints";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";
import { stakeNDeposits } from "../Abi/stakingDeposits";
import tokensClaimedSummaryNefi1 from "../Abi/tokensClaimedSummaryNefi1.json";
import tokensClaimedSummaryNefi2 from "../Abi/tokensClaimedSummaryNefi2.json";
import Nefi1ClaimDeod from "../Abi/Nefi1ClaimDeod.json";
import Nefi2ClaimDeod from "../Abi/Nefi2ClaimDeod.json";
import PurchaseClaimDeod from "../Abi/PurchaseClaimDeod.json";
import referralclaimOutput from "../Abi/referralclaimOutput.json";
import mergedTransfer from "../Abi/mergedTransfer.json";
import tokenwallet from "../../../image/wallet.png";
import totalwithdrawnImg from "../../../image/money-bag.png";
import drawalImg from "../../../image/wallets2.png";
import { encrypt } from "../../../utils/encrypt";
import proofOfStakeImg from "../../../image/proof-of-stake.png";
import Loading from "../LoaderPageSection/Loading";
import { getUserLevel } from "../../../utils/userLevels";
import { getCleanRevertReason } from "../../../utils/getCleanRevertReason";
import useFetchRewardClaimHistory from "../../../hooks/useFetchRewardClaimHistory";
import { isMonthlyRewardsDisabled } from "../../../utils/desableMonthlyRewardsAddresses";

const UserstakeA = () => {
    const navigate = useNavigate();
    const [auth, setAuth] = useAuth({});
    const [refferal, setRefferal] = useState("");
    const [address, setAddress] = useState("");
    const [owner, setOwner] = useState("");
    const [ownership, setOwnership] = useState("");
    const [loading, setLoading] = useState(false);
    const [assignloading, setAssignLoading] = useState(false);
    const [adminloading, setAdminLoading] = useState(false);
    const [totalAdminAllotment, setTotalAdminAllotment] = useState(0);
    const [rewardPool, setRewardPool] = useState("0");
    const [totalToken, setTotalToken] = useState("0");
    const [refferalEarn, setRefferalEarn] = useState("0");
    const [availableClaim, setAvailableClaim] = useState("0");
    const [referralEarningsWithdrawn, setreferralEarningsWithdrawn] =
        useState(0);
    const [userTotalWithdrawal, setUserTotalWithdrawal] = useState(0);
    const [adminAllotmentData, setAdminAllotmentData] = useState({
        toAddress: "",
        amount: ""
    });
    const [getBalance, setBalance] = useState("0");
    const [stackingData, setStackingData] = useState([]);
    const [wallet, setWallet] = useState("");
    const [amount, setAmount] = useState("");
    const [isFinalize, setIsFinalize] = useState(true);
    const [errors, setErrors] = useState({});
    const [copiedId, setCopiedId] = useState(null);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [usdtPrice, setUsdtPrice] = useState(0);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [totalClaimToken, setTotalClaimToken] = useState("0");
    const [transferAmount, setTransferAmount] = useState("");
    const [rErrors, setTErrors] = useState({});
    const [showSchedules, setShowSchedules] = useState(false);
    const [allotmentDate, setAllotmentDate] = useState(new Date("2026-04-15")); // Update this with specific date if needed
    const [depositRewardsAmt, setDepositRewardsAmt] = useState("");
    const [depositLoading, setDepositLoading] = useState(false);
    const { rewardClaimHistory } = useFetchRewardClaimHistory(auth?.user?.address, "stake-a");
    const isMonthlyClaimDisabled = isMonthlyRewardsDisabled(auth?.user?.address);
    const [userTotalWithdrawalWithoutRewards, setUserTotalWithdrawalWithoutRewards] = useState(0);

    const canClaim = !rewardClaimHistory || rewardClaimHistory.length === 0 || (() => {
        const lastClaim = rewardClaimHistory[0];
        if (!lastClaim || !lastClaim.createdAt) return true;
        const lastClaimDate = new Date(lastClaim.createdAt);
        const currentDate = new Date();
        const diffTime = currentDate.getTime() - lastClaimDate.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        return diffDays >= 30;
    })();

    const nextClaimDate = rewardClaimHistory && rewardClaimHistory.length > 0 && rewardClaimHistory[0]?.createdAt
        ? new Date(new Date(rewardClaimHistory[0].createdAt).getTime() + 31 * 24 * 60 * 60 * 1000).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
        : null;

    // console.log("rewardClaimHistory", rewardClaimHistory);

    const userLeveData = getUserLevel(totalToken);

    const start_and_end = (address) => {
        if (address !== undefined) {
            return (
                address.substr(0, 10) +
                "...." +
                address.substr(address.length - 10, address.length)
            );
        }
        return address;
    };

    const handleCopy = (text, id) => {
        navigator.clipboard.writeText(text);
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 1500);
    };

    const validate = () => {
        let newErrors = {};

        // Basic crypto wallet validation (ETH/BTC-like)
        const walletRegex =
            /^(0x[a-fA-F0-9]{40}|[13][a-km-zA-HJ-NP-Z1-9]{25,34})$/;

        if (!wallet) {
            newErrors.wallet = "Wallet address is required";
        } else if (!walletRegex.test(wallet)) {
            newErrors.wallet = "Invalid wallet address";
        }

        if (!amount) {
            newErrors.amount = "Amount is required";
        } else if (isNaN(amount) || Number(amount) <= 0) {
            newErrors.amount = "Enter valid amount";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleClaimAPI = async (from, to, amount, trxHash, sent_by) => {
        const headers = {
            "Content-Type": "application/json",
        };

        const bodyData = {
            sender_address: encrypt(from),
            recipient_address: encrypt(to),
            amount: encrypt(amount),
            trx_hash: encrypt(trxHash),
            sent_by: encrypt(sent_by),
        };
        try {
            const resp = await axios.post(
                `https://stackbackend.decentrawood.com/api/v1/stack`,
                bodyData,
                { headers },
            );
            if (resp?.data?.status === 200) {
                toast.success(resp?.data?.message);
            } else {
                toast.error(resp?.data?.message || "Something went wrong");
            }
        } catch (error) {
            if (error.response.status === 400) {
                var err_400 = error?.response?.data?.message;
                toast.error(err_400);
            } else if (error.response.status === 401) {
                const err_401 = error?.response?.data?.message;
                toast.error(err_401);
            } else if (error.response.status === 404) {
                const err_404 = error?.response?.data?.message;
                toast.error(err_404);
            } else if (error.response.status === 500) {
                const err_500 = error?.response?.data?.message;
                toast.error(err_500);
            } else {
                console.log("Error in Register", error);
                toast.error("something went wrong");
            }
        }
    };
    const getFinalizeStatus = async (address) => {
        try {
            const resp = await axios.get(
                `https://stackbackend.decentrawood.com/api/v1/stake/finalize/${address}`,
            );
            console.log(resp.data.data);
            if (resp?.data?.data.length == 0) {
                setIsFinalize(false);
            } else if (resp?.data?.data[0].isFinalised == false) {
                setIsFinalize(false);
            } else if (resp?.data?.data[0].isFinalised == true) {
                setIsFinalize(true);
            }
        } catch (error) {
            console.log(error);
        }
    };
    console.log(isFinalize);
    const handleSubmit = async () => {
        if (validate()) {
            setAssignLoading(true);
            try {
                let provider;
                if (window.ethereum) {
                    provider = window.ethereum;
                } else if (window.web3) {
                    provider = window.web3.currentProvider;
                } else {
                    window.alert("No ethereum browser !checkout metamask");
                }
                if (provider) {
                    if (provider !== window.ethereum) {
                        console.error(
                            "Not window.ethereum.Do you have multiple wallets installed",
                        );
                    }
                    await provider.request({
                        method: "eth_requestAccounts",
                    });
                }
                const newProvider = new ethers.providers.Web3Provider(
                    window.ethereum,
                );
                const signer = newProvider.getSigner();
                const currentaccount = await signer.getAddress();
                const address = currentaccount.toLowerCase();
                const storeAddress = auth?.user?.address;
                if (address === storeAddress) {
                    const StakeContract = new ethers.Contract(
                        stakeAContractAddress,
                        stakeAContractABI,
                        signer,
                    );
                    const amountInWei = ethers.utils.parseUnits(
                        amount.toString(),
                        18,
                    );
                    const txn = await StakeContract.userTransfer(
                        wallet,
                        amountInWei,
                    );
                    const receipttxn1 = await txn.wait();
                    if (receipttxn1.status !== 1) {
                        toast.error("Error");
                    } else {
                        const hash = await receipttxn1.transactionHash;
                        await handleClaimAPI(
                            address,
                            wallet,
                            amount,
                            hash,
                            "self",
                        );
                    }
                } else {
                    toast.error("Connect correct wallet");
                }
            } catch (error) {
                console.log("loadBlockchainData", error);
                toast.error(`${JSON.stringify(error.reason)}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            setAssignLoading(false);
            // window.location.reload(false);
        }
    };

    /*Switch to Testnet*/
    const networkData = {
        sepolia: {
            chainId: "0xaa36a7",
            chainName: "Sepolia Testnet",
            nativeCurrency: {
                name: "Sepolia Ether",
                symbol: "ETH",
                decimals: 18,
            },
            rpcUrls: ["https://rpc.sepolia.org"],
            blockExplorerUrls: ["https://sepolia.etherscan.io"],
        },
        bnbTestnet: {
            chainId: "0x61",
            chainName: "BNB Smart Chain Testnet",
            nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
            rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
            blockExplorerUrls: ["https://testnet.bscscan.com"],
        },

        /* --- BSC MAINNET --- */
        bsc: {
            chainId: "0x38", // 56 decimal
            chainName: "BNB Smart Chain Mainnet",
            nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
            rpcUrls: ["https://bsc-dataseed.binance.org/"],
            blockExplorerUrls: ["https://bscscan.com"],
        },

        /* --- POLYGON MAINNET --- */
        polygon: {
            chainId: "0x89", // 137 decimal
            chainName: "Polygon Mainnet",
            nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
            rpcUrls: ["https://polygon-rpc.com/"],
            blockExplorerUrls: ["https://polygonscan.com"],
        },
    };
    const switchNetworks = async (networkName) => {
        const network = networkData[networkName];
        try {
            await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: network.chainId }],
            });
            console.log("network switched");
        } catch (switchError) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
                try {
                    await window.ethereum.request({
                        method: "wallet_addEthereumChain",
                        params: [network],
                    });
                    console.log("network switched");
                } catch (addError) {
                    console.log(addError);
                    // handle "add" error
                }
            }
            // handle other "switch" errors
        }
    };

    const loadData = async () => {
        setLoading(true);
        try {
            let provider;
            if (window?.ethereum) {
                provider = window?.ethereum;
            } else if (window?.web3) {
                provider = window?.web3?.currentProvider;
            } else {
                window.alert("No ethereum browser !checkout metamask");
            }
            if (provider) {
                if (provider !== window?.ethereum) {
                    console.error(
                        "Not window.ethereum.Do you have multiple wallets installed",
                    );
                }
                await provider.request({
                    method: "eth_requestAccounts",
                });
            }
            const oldProvider = new ethers.providers.Web3Provider(
                window.ethereum,
            );
            const network = await oldProvider.getNetwork();
            await switchNetworks("bsc");
            const newProvider = new ethers.providers.Web3Provider(
                window?.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            const address = currentaccount.toLowerCase();
            // const address = "0xd6D51119fFE9DDf2068B0997D35Ff9C4f1C8bB67".toLowerCase();
            const StakeContract = new ethers.Contract(
                stakeAContractAddress,
                stakeAContractABI,
                signer,
            );
            const owner = await StakeContract.owner();
            setOwner(owner);

            const totalStaked = await StakeContract.userTotalAllotment(address);
            setTotalToken(ethers.utils.formatEther(totalStaked));

            const totaladminAllotments = await StakeContract.totalAdminAllotment()
            setTotalAdminAllotment(ethers.utils.formatEther(totaladminAllotments))

            try {
                const rewardPoolVal = await StakeContract.rewardPool();
                setRewardPool(ethers.utils.formatEther(rewardPoolVal));
            } catch (err) {
                console.log("Error fetching rewardPool", err);
            }

            const availableReward =
                await StakeContract.availableReward(address);
            setRefferalEarn(ethers.utils.formatEther(availableReward));

            const availablePrincipal =
                await StakeContract.availablePrincipal(address);
            setAvailableClaim(ethers.utils.formatEther(availablePrincipal));

            const withdrawnPrincipal =
                await StakeContract.userTotalWithdrawal(address);
                setUserTotalWithdrawalWithoutRewards(Number(ethers.utils.formatEther(withdrawnPrincipal)));
            const rewardsClaimed =
                await StakeContract.userTotalRewardsClaimed(address);
            // console.log(
            //     "withdrawnPrincipal",
            //     ethers.utils.formatEther(withdrawnPrincipal),
            // );
            // console.log(
            //     "rewardsClaimed",
            //     ethers.utils.formatEther(rewardsClaimed),
            // );
            setUserTotalWithdrawal(
                Number(ethers.utils.formatEther(withdrawnPrincipal)) + Number(ethers.utils.formatEther(rewardsClaimed))
            );
            setTotalClaimToken(0);
            setreferralEarningsWithdrawn(
                ethers.utils.formatEther(rewardsClaimed),
            ); // Storing rewardsClaimed here which will automatically be added in the UI to total Withdrawn!
        } catch (error) {
            console.log("loadBlockchainData", error);
        }
        setLoading(false);
    };
    const filteredDeposits = stakeNDeposits.filter(
        (item) => item.address.toLowerCase() === address.toLowerCase(),
    );

    const nefi1Data = tokensClaimedSummaryNefi1.filter(
        (item) => item.address.toLowerCase() === address.toLowerCase(),
    );

    const nefi2Data = tokensClaimedSummaryNefi2.filter(
        (item) => item.address.toLowerCase() === address.toLowerCase(),
    );

    const purchaseClaimData = PurchaseClaimDeod.filter(
        (item) => item.user.toLowerCase() === address.toLowerCase(),
    );

    const referralClaimData = referralclaimOutput.filter(
        (item) => item.user.toLowerCase() === address.toLowerCase(),
    );

    const mergedTransferData = mergedTransfer.filter(
        (item) => item.from.toLowerCase() === address.toLowerCase(),
    );

    const calculateGrandTotalDeod = () => {
        let total = new BigNumber(0);
        nefi1Data.forEach((value) => {
            const deodData = Nefi1ClaimDeod.find(
                (item) =>
                    item.user.toLowerCase() === value.address.toLowerCase(),
            );
            if (deodData) total = total.plus(deodData.finaltotalAllotment || 0);
        });
        nefi2Data.forEach((value) => {
            const deodData = Nefi2ClaimDeod.find(
                (item) =>
                    item.user.toLowerCase() === value.address.toLowerCase(),
            );
            if (deodData) total = total.plus(deodData.finaltotalAllotment || 0);
        });
        purchaseClaimData.forEach((item) => {
            total = total.plus(item.finaltotalAllotment || 0);
        });
        referralClaimData.forEach((item) => {
            total = total.plus(item.finaltotalReferral || 0);
        });
        return total;
    };
    const grandTotalDeod = calculateGrandTotalDeod();

    const handleGetStackingData = async () => {
        const token = auth?.user?.token;
        const headers = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
        try {
            const resp = await axios.get(
                `https://stackbackend.decentrawood.com/api/v1/stack/${auth?.user?.address}`,
                {
                    headers,
                },
            );
            if (resp.status === 200) {
                if (resp?.data?.status === 200) {
                    setStackingData(resp?.data?.data);
                } else {
                    toast.error("Error", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } else {
                toast.error("Error", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            if (error.response.status === 400) {
                var err_400 = error?.response?.data?.message;
                toast.error(err_400);
            } else if (error.response.status === 401) {
                const err_401 = error?.response?.data?.message;
                toast.error(err_401);
            } else if (error.response.status === 404) {
                const err_404 = error?.response?.data?.message;
                toast.error(err_404);
            } else if (error.response.status === 500) {
                const err_500 = error?.response?.data?.message;
                toast.error(err_500);
            } else {
                console.log("Error in Register", error);
                toast.error("something went wrong");
            }
        }
    };
    function timestampToDate(seconds) {
        const date = new Date(seconds * 1000); // Convert to milliseconds
        return date.toLocaleString(); // Example: "6/30/2025, 7:45:12 PM"
    }

    const claimAllPrincipal = async () => {
        setLoading(true);
        try {
            let provider;
            if (window.ethereum) {
                provider = window.ethereum;
            } else if (window.web3) {
                provider = window.web3.currentProvider;
            } else {
                window.alert("No ethereum browser !checkout metamask");
            }
            if (provider) {
                if (provider !== window.ethereum) {
                    console.error(
                        "Not window.ethereum.Do you have multiple wallets installed",
                    );
                }
                await provider.request({
                    method: "eth_requestAccounts",
                });
            }
            const newProvider = new ethers.providers.Web3Provider(
                window.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            const address = currentaccount.toLowerCase();
            const storeAddress = auth?.user?.address;
            if (address === storeAddress) {
                const StakeContract = new ethers.Contract(
                    stakeAContractAddress,
                    stakeAContractABI,
                    signer,
                );
                const txn = await StakeContract.claimAllPrincipal();
                const receipttxn1 = await txn.wait();
                if (receipttxn1.status !== 1) {
                    toast.error("Error");
                } else {
                    const hash = await receipttxn1.transactionHash;
                    //   await handleClaimAPI(hash);
                    alert("claim Successful");
                }
            } else {
                toast.error("Connect correct wallet");
            }
        } catch (error) {
            console.log("loadBlockchainData", error);
            toast.error(`${JSON.stringify(error.reason)}`, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setLoading(false);
        window.location.reload(false);
    };
    const transferOwnership = async () => {
        try {
            const newProvider = new ethers.providers.Web3Provider(
                window?.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
            const address = currentaccount.toLowerCase();
            const StakeContract = new ethers.Contract(
                stakeAContractAddress,
                stakeAContractABI,
                signer,
            );
            const withdraw = await StakeContract.transferOwnership(ownership);
            const rcpt = await withdraw.wait();
            alert("Transfer Ownership Successful");
        } catch (error) {
            console.log(error);
            alert(error.message);
        }
    };
    const handleAdminTransfer = async () => {
        let newErrors = {};

        if (!from || from.length !== 42) {
            newErrors.from = "Invalid From Address";
        }

        if (!to || to.length !== 42) {
            newErrors.to = "Invalid To Address";
        }

        if (!transferAmount || transferAmount <= 0) {
            newErrors.amount = "Enter valid amount";
        }

        setTErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        setAdminLoading(true);
        try {
            let provider;
            if (window.ethereum) {
                provider = window.ethereum;
            } else if (window.web3) {
                provider = window.web3.currentProvider;
            } else {
                window.alert("No ethereum browser !checkout metamask");
            }
            if (provider) {
                if (provider !== window.ethereum) {
                    console.error(
                        "Not window.ethereum.Do you have multiple wallets installed",
                    );
                }
                await provider.request({
                    method: "eth_requestAccounts",
                });
            }
            const newProvider = new ethers.providers.Web3Provider(
                window.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            const address = currentaccount.toLowerCase();
            const storeAddress = auth?.user?.address;
            if (address === storeAddress) {
                const StakeContract = new ethers.Contract(
                    stakeAContractAddress,
                    stakeAContractABI,
                    signer,
                );
                const amountInWei = ethers.utils.parseUnits(
                    transferAmount.toString(),
                    18,
                );

                const txn = await StakeContract.adminTransfer(
                    from,
                    to,
                    amountInWei,
                );
                const receipttxn1 = await txn.wait();
                if (receipttxn1.status !== 1) {
                    toast.error("Error");
                } else {
                    const hash = await receipttxn1.transactionHash;
                    await handleClaimAPI(
                        from,
                        to,
                        transferAmount,
                        hash,
                        "admin",
                    );
                }
            } else {
                toast.error("Connect correct wallet");
            }
        } catch (error) {
            console.log("loadBlockchainData", error);
            toast.error(`${JSON.stringify(error.reason)}`, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setAdminLoading(false);
        window.location.reload(false);
    };
    const handleClaimReward = async () => {
        if (isMonthlyClaimDisabled) {
            toast.error("Monthly rewards claim is disabled for this address.");
            return;
        }
        if (!canClaim) {
            toast.error("You can only claim rewards once every 30 days.");
            return;
        }
        setLoading(true);
        try {
            let provider;
            if (window.ethereum) {
                provider = window.ethereum;
            } else if (window.web3) {
                provider = window.web3.currentProvider;
            } else {
                window.alert("No ethereum browser !checkout metamask");
            }
            if (provider) {
                if (provider !== window.ethereum) {
                    console.error(
                        "Not window.ethereum.Do you have multiple wallets installed",
                    );
                }
                await provider.request({
                    method: "eth_requestAccounts",
                });
            }
            const newProvider = new ethers.providers.Web3Provider(
                window.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            const address = currentaccount.toLowerCase();
            const storeAddress = auth?.user?.address;
            if (address === storeAddress) {
                const StakeContract = new ethers.Contract(
                    stakeAContractAddress,
                    stakeAContractABI,
                    signer,
                );
                const txn = await StakeContract.claimAllRewards();
                const receipttxn1 = await txn.wait();
                if (receipttxn1.status !== 1) {
                    toast.error("Error");
                } else {
                    const hash = await receipttxn1.transactionHash;
                    const payload = {
                        type: encrypt("stake-a"),
                        user_address: encrypt(address),
                        trx_hash: encrypt(hash),
                        claim_amount: encrypt(refferalEarn)
                    };
                    const res = await claimRewards(payload);
                    if (res?.status === 200) {
                        toast.success(res?.message || "Claim Successfully");
                        loadData();
                    } else {
                        toast.error(res?.message || "Something went wrong");
                    }
                }
            } else {
                toast.error("Connect correct wallet");
            }
        } catch (error) {
            console.log("loadBlockchainData", error);
            toast.error(getCleanRevertReason(error), {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setLoading(false);
        // window.location.reload(false);
    };
    const handleEmergencyWithdraw = async () => {
        try {
            const newProvider = new ethers.providers.Web3Provider(
                window?.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
            const address = currentaccount.toLowerCase();
            const StakeContract = new ethers.Contract(
                stakeAContractAddress,
                stakeAContractABI,
                signer,
            );
            // const withdraw = await StakeContract.emergencyWithdraw()
            // const rcpt = await withdraw.wait()
            alert("Emergency Token Withdrawn");
        } catch (error) { }
    };

    const handleAdminAllotment = async () => {
        const validateResult = () => {
            let err = {};
            const walletRegex =
                /^(0x[a-fA-F0-9]{40}|[13][a-km-zA-HJ-NP-Z1-9]{25,34})$/;

            if (!walletRegex.test(adminAllotmentData.toAddress)) {
                err.toAddress = "Please enter a valid wallet address";
            }
            if (!/^[1-9]\d*(\.\d+)?$/.test(adminAllotmentData.amount)) {
                err.amount = "Please enter a valid amount";
            }

            setTErrors(err);
            return Object.keys(err).length === 0;
        };

        if (!validateResult()) return;
        setAdminLoading(true);
        try {
            await switchNetworks('bsc')
            const newProvider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = newProvider.getSigner();
            const contract = new ethers.Contract(
                stakeAContractAddress,
                stakeAContractABI,
                signer,
            );
            // console.log({
            //     toAddress: adminAllotmentData.toAddress,
            //     realAmt: adminAllotmentData.amount,
            //     amount: ethers.utils.parseUnits(adminAllotmentData.amount, 18).toString()
            // })
            const ethToWeiAmt = ethers.utils.parseUnits(adminAllotmentData.amount.toString(), 18).toString();
            const tx = await contract.adminAllotment(adminAllotmentData.toAddress, ethToWeiAmt);
            const rcpt = await tx.wait();
            if (rcpt.status === 1) {
                toast.success("Tokens allotted successfully");
                setAdminAllotmentData({ toAddress: "", amount: "" });
            } else {
                toast.error("Failed to allot tokens");
            }
        } catch (error) {
            console.error(error);
            alert("Error in allotment: " + error.message);
        } finally {
            setAdminLoading(false);
        }
    }

    const handleDepositRewards = async () => {
        if (!depositRewardsAmt || isNaN(depositRewardsAmt) || Number(depositRewardsAmt) <= 0) {
            toast.error("Please enter a valid amount");
            return;
        }

        console.log("depositRewards inputs:", {
            amount: depositRewardsAmt
        });

        setDepositLoading(true);
        try {
            await switchNetworks('bsc');
            const newProvider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = newProvider.getSigner();
            const contract = new ethers.Contract(
                stakeAContractAddress,
                stakeAContractABI,
                signer,
            );
            const tokenContract = new ethers.Contract(
                bnbDeod,
                bnbDeodABI,
                signer
            );
            const ethToWeiAmt = ethers.utils.parseUnits(depositRewardsAmt.toString(), 18).toString();
            const approveTx = await tokenContract.approve(
                stakeAContractAddress,
                ethToWeiAmt
            );
            await approveTx.wait();
            const tx = await contract.depositRewards(ethToWeiAmt);
            const rcpt = await tx.wait();
            if (rcpt.status === 1) {
                toast.success("Rewards deposited successfully");
                setDepositRewardsAmt("");
            } else {
                toast.error("Failed to deposit rewards");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error depositing rewards: " + (error.reason || error.message));
        } finally {
            setDepositLoading(false);
        }
    };

    useEffect(() => {
        async function handleGetParaswapPrice() {
            if (totalToken == 0) {
                setUsdtPrice(0);
            } else {
                try {
                    let x;
                    x = totalToken * 10 ** 18;
                    let z = new BigNumber(x);
                    let a = z.toFixed();
                    const Paraswap = `https://backend.decentrawood.com/commonAPI/getDeodPrice`;
                    console.log("Paraswap", a);
                    const getParaswapData = await axios.get(Paraswap);
                    if (getParaswapData.status === 200) {
                        let finalUSDTPrice =
                            getParaswapData?.data?.data?.priceRoute?.destAmount;
                        finalUSDTPrice = (finalUSDTPrice / 10 ** 18).toFixed(2);
                        setUsdtPrice((+totalToken / finalUSDTPrice).toFixed(2));
                    }
                } catch (error) {
                    console.log("error in deod price paraswap api", error);
                }
            }
        }
        handleGetParaswapPrice();
    }, [totalToken]);

    const confirmFinalize = async () => {
        try {
            // return alert('error occured')
            const newProvider = new ethers.providers.Web3Provider(
                window?.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
            const address = currentaccount.toLowerCase();
            const StakeContract = new ethers.Contract(
                stakeAContractAddress,
                stakeAContractABI,
                signer,
            );
            const payload = {
                sender_address: encrypt(address),
                isFinalised: encrypt(true),
            };
            // const withdraw = await StakeContract.emergencyWithdraw()
            // const rcpt = await withdraw.wait()
            const apiUrl = `https://stackbackend.decentrawood.com/api/v1/stake/finalize/`;
            const resp = await axios.post(apiUrl, payload);
            console.log(resp);
            await getFinalizeStatus(address);
            setShowConfirmModal(false);
            alert("Transfer Finalised");
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        async function handleData() {
            await loadData();
        }
        handleData();

        return () => {
            if (window?.ethereum) {
                switchNetworks("bsc").catch(console.error);
            }
        };
    }, []);

    useEffect(() => {
        if (
            auth?.user?.address &&
            auth?.user?.referralAddress &&
            auth?.user?.token
        ) {
            setRefferal(auth?.user?.referralAddress);
            setAddress(auth?.user?.address);
            // setAddress(`0xd4068cf47D8EEFf33217d7926aE38bf066f738E4`.toLowerCase());
            handleGetStackingData();
        }
    }, [auth]);

    useEffect(() => {
        async function handleGetParaswapPrice() {
            if (getBalance == 0) {
                setUsdtPrice(0);
            } else {
                try {
                    let x;
                    x = getBalance * 10 ** 18;
                    let z = new BigNumber(x);
                    let a = z.toFixed();
                    const Paraswap = `https://backend.decentrawood.com/commonAPI/getDeodPrice`;
                    console.log("Paraswap", a);
                    const getParaswapData = await axios.get(Paraswap);
                    if (getParaswapData.status === 200) {
                        let finalUSDTPrice =
                            getParaswapData?.data?.data?.priceRoute?.destAmount;
                        finalUSDTPrice = (finalUSDTPrice / 10 ** 18).toFixed(2);
                        setUsdtPrice((getBalance / finalUSDTPrice).toFixed(2));
                    }
                } catch (error) {
                    console.log("error in deod price paraswap api", error);
                }
            }
        }
        handleGetParaswapPrice();
    }, [getBalance]);


    const totalAvailableToken = Number(totalToken) - Number(userTotalWithdrawalWithoutRewards);

    return (
        <div>
            <UserPageSection>
                {loading && <Loading loading={loading} text={"Loading..."} />}
                <h1 className="text-white f-bold mb-2" style={{}}>Welcome back <span style={{ color: "#e87722ff", textTransform: "capitalize", fontWeight: "bold", }}>{userLeveData?.name ? `${userLeveData?.name}` : ''}</span> <img style={{ width: "auto", height: "40px" }} src={userLeveData?.image} alt={userLeveData?.name} /></h1>
                <div>
                    {/* <div className="marquee">
            <h3 className="text-warning fw-bolder">Data migration is in process, it will be fully completed by next week</h3>

            <style jsx>{`
                .marquee {
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                }

                .marquee h3 {
                    display: inline-block;
                    padding-left: 100%;
                    animation: marquee 10s linear infinite;
                }

                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-100%); }
                }
            `}</style>
          </div> */}
                    {/* <div className="row">

            <div className="col-6">
              <button
                className="btn connect-btn mx-2 boobtn"
              // onClick={() => navigate("/stack-token-vN")}
              >
                Stake Token N
              </button>
            </div>
          </div> */}

                    <div className="dashboard-cards-grid">
                        {/* Card 1: Staked Assets */}
                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Token Staked
                                </span>
                                <div className="card-custom-icon">
                                    <img
                                        src={proofOfStakeImg}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "70px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {totalAvailableToken.toFixed(2)}
                            </div>
                            <div className="dashboard-card-subtitle">DEOD</div>
                        </div>

                        {/* Card 2: Staked Amount (USDT value) */}
                        {/* <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">Staked Amount</span>
                                <div className="card-custom-icon">
                                    <i className="bi bi-coin" style={{ color: '#f5841f' }}></i>
                                </div>
                            </div>
                            <div className="dashboard-card-value">{usdtPrice}</div>
                            <div className="dashboard-card-subtitle">USDT Value</div>
                            </div> */}

                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Available Monthly Rewards
                                </span>
                                <div className="card-custom-icon">
                                    <i
                                        className="bi bi-clock-history"
                                        style={{ color: "#f5841f" }}
                                    ></i>
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {(+refferalEarn).toFixed(2)}
                            </div>
                            <button
                                className="claim-btn"
                                onClick={() => handleClaimReward()}
                                style={{ marginTop: "12px" }}
                                disabled={isMonthlyClaimDisabled}
                                title={isMonthlyClaimDisabled ? "Monthly rewards claim is disabled for this address" : canClaim ? "Claim rewards" : "Claim available after 30 days"}
                            >
                                Claim
                            </button>
                            <div className="dashboard-card-subtitle mt-2">
                                Your rewards can be claimed once a month.{nextClaimDate && ` Next claim date: ${nextClaimDate}`}
                            </div>
                        </div>

                        <div className="dashboard-card card-large">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Staked Token Value
                                </span>
                                <div className="dashboard-card-icon card-icon-blue">
                                    <img
                                        src={tokenwallet}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                ${usdtPrice}{" "}
                            </div>
                            <div className="card-stats-row">
                                <div className="card-stat-item">
                                    <div className="card-stat-label">
                                        Tokens Staked
                                    </div>
                                    <div
                                        className="card-stat-value"
                                        style={{ color: "#f5841f" }}
                                    >
                                        {(+totalToken).toFixed(2)} DEOD
                                    </div>
                                </div>
                                {refferalEarn > 0.0001 && (
                                    <div className="card-stat-item">
                                        <div className="card-stat-label">
                                            Reward Earnings
                                        </div>
                                        <div
                                            className="card-stat-value"
                                            style={{ color: "#f5841f" }}
                                        >
                                            {(+refferalEarn).toFixed(2)} DEOD
                                        </div>
                                    </div>
                                )}
                            </div>
                            {/* <button
                                className="claim-btn-outline"
                                onClick={() => claimAllPrincipal()}
                            >
                                Claim Principal
                            </button> */}
                        </div>

                        {/* Card 2: Total Withdrawal */}
                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Total Withdrawal
                                </span>
                                <div className="card-custom-icon">
                                    <img
                                        src={totalwithdrawnImg}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "70px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {(+userTotalWithdrawal).toFixed(2)}
                            </div>
                            <div className="dashboard-card-subtitle">DEOD</div>
                        </div>

                        {/* Card 3: Staked Token Value — Large Card */}

                        {/* Card 4: Staked Period (Mock/Constant as in Stake 2/3) */}
                        {/* <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">Staked Period</span>
                                <div className="card-custom-icon">
                                    <i className="bi bi-calendar3" style={{ color: '#f5841f' }}></i>
                                </div>
                            </div>
                            <div className="dashboard-card-value">V5 Term</div>
                            <div className="dashboard-card-subtitle">Staking Period</div>
                            </div> */}

                        {/* Card 5: Available Release — Referral Earnings Summary card equivalent */}

                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Release of Principal Amount
                                </span>
                                <div className="card-custom-icon">
                                    <img
                                        src={drawalImg}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "70px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {(+availableClaim).toFixed(2)}
                            </div>
                            {/* <div className="dashboard-card-subtitle">
                                24 Feb-2026 Onwards
                            </div> */}
                            <div className="d-flex justify-content-between">
                                {/* <button
                                    className="claim-btn"
                                    onClick={() => {}}
                                    style={{ marginTop: "12px" }}
                                    disabled
                                >
                                    Schedules
                                </button> */}
                                <button
                                    className="claim-btn"
                                    onClick={() =>
                                        setShowSchedules(!showSchedules)
                                    }
                                    style={{ marginTop: "12px" }}
                                >
                                    Schedules
                                </button>
                            </div>
                        </div>
                    </div>

                    {showSchedules && (
                        <div className="schedules-section mt-4 mb-4">
                            <style>
                                {`
                                @media (min-width: 992px) {
                                    .col-five-lg {
                                        flex: 0 0 20% !important;
                                        max-width: 20% !important;
                                    }
                                }
                            `}
                            </style>
                            <h4
                                className="text-white mb-3"
                                style={{
                                    textAlign: "left",
                                    paddingLeft: "10px",
                                }}
                            >
                                Release Schedule
                            </h4>
                            <div className="row g-3">
                                {[3, 4, 5, 6, 7].map((yearsAfter, index) => {
                                    const releaseDate = new Date(allotmentDate);
                                    releaseDate.setFullYear(
                                        releaseDate.getFullYear() + yearsAfter,
                                    );
                                    const amount = (
                                        (Number(totalToken) || 0) * 0.2
                                    ).toFixed(2);

                                    return (
                                        <div
                                            key={index}
                                            className="col-6 col-md-4 col-five-lg"
                                        >
                                            <div className="dashboard-card h-100">
                                                <div className="dashboard-card-header">
                                                    <span className="dashboard-card-title">
                                                        Release {index + 1}
                                                    </span>
                                                </div>
                                                <div
                                                    className="dashboard-card-value fs-5 mt-2"
                                                    style={{ color: "#f5841f" }}
                                                >
                                                    {amount}
                                                </div>
                                                <div
                                                    className="dashboard-card-subtitle mt-1"
                                                    style={{
                                                        color: "#8d8c8bff",
                                                    }}
                                                >
                                                    DEOD
                                                </div>
                                                <div className="dashboard-card-subtitle mt-3">
                                                    Release Date:
                                                    <br />
                                                    <strong className="text-white">
                                                        {releaseDate.toLocaleDateString()}
                                                    </strong>
                                                </div>
                                                <div
                                                    className="dashboard-card-subtitle mt-2"
                                                    style={{
                                                        fontSize: "0.80rem",
                                                    }}
                                                >
                                                    (20% after {yearsAfter}{" "}
                                                    years)
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {(address.toLowerCase() ==
                        `0x4c521a1A1F77D0bd19519f2F9b635a3626B619AF`.toLowerCase() ||
                        address.toLowerCase() == owner.toLowerCase()) && (
                            <div className="d-flex flex-column gap-3 mb-4 w-100">
                                <div className="d-flex flex-wrap gap-3 w-100 mb-2">
                                    <div className="col-12 col-md-5 d-flex p-0">
                                        <div className="app-card w-100 d-flex flex-column" style={{ minHeight: "140px" }}>
                                            <div>
                                                <div className="app-card__header">
                                                    <span className="app-card__title">
                                                        Total Staked (Admin)
                                                    </span>
                                                    <div className="app-card__icon app-card__icon--blue">
                                                        <i className="bi bi-bank" style={{ fontSize: "1.2rem", color: "#f5841f" }}></i>
                                                    </div>
                                                </div>
                                                <div className="mt-3 fs-3 fw-bold" style={{ color: "#f5841f" }}>
                                                    {(+totalAdminAllotment).toFixed(2)} DEOD
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-5 d-flex p-0">
                                        <div className="app-card w-100 d-flex flex-column" style={{ minHeight: "140px" }}>
                                            <div>
                                                <div className="app-card__header">
                                                    <span className="app-card__title">
                                                        Reward Pool (Admin)
                                                    </span>
                                                    <div className="app-card__icon app-card__icon--blue">
                                                        <i className="bi bi-gift" style={{ fontSize: "1.2rem", color: "#f5841f" }}></i>
                                                    </div>
                                                </div>
                                                <div className="mt-3 fs-3 fw-bold" style={{ color: "#f5841f" }}>
                                                    {(+rewardPool).toFixed(2)} DEOD
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap gap-3 w-100">
                                    <div className="col-12 col-md-5 d-flex p-0">
                                        <div className="app-card w-100 d-flex flex-column">
                                            <div>
                                                <div className="app-card__header">
                                                    <span className="app-card__title">
                                                        Admin Allotment
                                                    </span>

                                                    <div className="app-card__icon app-card__icon--blue">
                                                        <img
                                                            src={drawalImg}
                                                            alt=""
                                                            className="app-card__img"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="app-form mt-3">
                                                    {/* To Address */}
                                                    <div className="app-form__group">
                                                        <input
                                                            type="text"
                                                            className={`app-form__input ${rErrors.toAddress ? "app-form__input--error" : ""}`}
                                                            placeholder="To Address"
                                                            value={adminAllotmentData.toAddress}
                                                            onChange={(e) =>
                                                                setAdminAllotmentData({ ...adminAllotmentData, toAddress: e.target.value })
                                                            }
                                                        />
                                                        {rErrors.toAddress && (
                                                            <span className="app-form__error">
                                                                {rErrors.toAddress}
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Amount */}
                                                    <div className="app-form__group">
                                                        <input
                                                            type="number"
                                                            className={`app-form__input ${rErrors.amount ? "app-form__input--error" : ""}`}
                                                            placeholder="Enter Amount"
                                                            value={adminAllotmentData.amount}
                                                            onChange={(e) =>
                                                                setAdminAllotmentData({ ...adminAllotmentData, amount: e.target.value })
                                                            }
                                                        />
                                                        {rErrors.amount && (
                                                            <span className="app-form__error">
                                                                {rErrors.amount}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                className="app-btn app-btn--primary mt-auto py-2 flex items-center justify-center gap-2"
                                                onClick={handleAdminAllotment}
                                                disabled={adminloading}
                                            >
                                                {adminloading ? (
                                                    <>
                                                        <span className="loader"></span>
                                                        Transferring...
                                                    </>
                                                ) : (
                                                    "Allot Tokens"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-5 d-flex p-0">
                                        <div className="app-card w-100 d-flex flex-column">
                                            <div>
                                                <div className="app-card__header">
                                                    <span className="app-card__title">
                                                        Deposit Rewards
                                                    </span>

                                                    <div className="app-card__icon app-card__icon--blue">
                                                        <img
                                                            src={drawalImg}
                                                            alt=""
                                                            className="app-card__img"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="app-form mt-3">
                                                    {/* Amount */}
                                                    <div className="app-form__group">
                                                        <input
                                                            type="number"
                                                            className={`app-form__input`}
                                                            placeholder="Enter Amount"
                                                            value={depositRewardsAmt}
                                                            onChange={(e) =>
                                                                setDepositRewardsAmt(e.target.value)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                className="app-btn app-btn--primary mt-auto py-2 flex items-center justify-center gap-2"
                                                onClick={handleDepositRewards}
                                                disabled={depositLoading}
                                            >
                                                {depositLoading ? (
                                                    <>
                                                        <span className="loader"></span>
                                                        Depositing...
                                                    </>
                                                ) : (
                                                    "Deposit Rewards"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    {/* <div className="row justify-content-center my-4">
            <div className="col-12 col-md-6">
              <div className="card cus-card-token-ad text-center">
                <div className="card-body">
                  <h6>Total DEOD Alloted</h6>
                </div>
                <p className="mt-1"><strong>{grandTotalDeod.isGreaterThan(0) ? grandTotalDeod.toFixed(5) : "0"} DEOD</strong></p>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="card cus-card-token-ad">
                <div className="card-body">

              
                  <h5 className="text-center mb-4">Assign Tokens</h5>

                  <div className="mb-3">
                    <label className="form-label">Enter Wallet Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="0x..."
                      value={wallet}
                      onChange={(e) => setWallet(e.target.value)}
                    />
                    {errors.wallet && (
                      <small className="text-danger">{errors.wallet}</small>
                    )}
                  </div>

                 
                  <div className="mb-3">
                    <label className="form-label">Enter Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                    {errors.amount && (
                      <small className="text-danger">{errors.amount}</small>
                    )}
                  </div>

                
                  <button
                    className="btn btn-primary w-100"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>

                </div>
              </div>
            </div>
         
            {(address.toLowerCase() == `0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2`.toLowerCase() || address.toLowerCase() == owner.toLowerCase()) && <div className="col-12 col-md-6">
              <div className="card cus-card-token-ad text-center">
                <div className="card-body">
                  <h6>Ownership Transfer</h6>
                </div>
                <input type="text" placeholder="Eg. 0x0123..321" className="form form-control px-2 my-3" value={ownership} onChange={(e) => setOwnership(e.target.value)} />
                <button
                  className="btn connect-btn"
                  onClick={() => transferOwnership()}
                >
                  Transfer Ownership
                </button>
              </div>
            </div>}
          </div> */}

                    {/* Reward Claim History Table */}
                    {rewardClaimHistory && rewardClaimHistory.length > 0 && (
                        <div className="mt-5 mb-4 w-100">
                            <h4
                                className="text-white mb-3"
                                style={{
                                    textAlign: "left",
                                    paddingLeft: "10px",
                                }}
                            >
                                Reward Claim History
                            </h4>
                            <div className="app-table-container">
                                <table className="app-table">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Claim Amount</th>
                                            <th>User Address</th>
                                            <th>Trx Hash</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rewardClaimHistory.map((item, index) => (
                                            <tr key={item._id || index}>
                                                <td>{index + 1}</td>
                                                <td style={{ color: "#f5841f", fontWeight: "bold" }}>
                                                    {item.claim_amount} DEOD
                                                </td>
                                                <td className="app-address-cell">
                                                    <span className="app-address-text" style={{ fontFamily: "monospace" }}>
                                                        {start_and_end(item.user_address)}
                                                    </span>
                                                    <button
                                                        className="btn btn-sm btn-link text-warning p-0 ms-2"
                                                        onClick={() => handleCopy(item.user_address, `addr-${index}`)}
                                                        title="Copy Address"
                                                    >
                                                        {copiedId === `addr-${index}` ? (
                                                            <i className="bi bi-check2 text-success"></i>
                                                        ) : (
                                                            <i className="bi bi-copy"></i>
                                                        )}
                                                    </button>
                                                </td>
                                                <td className="app-address-cell">
                                                    <span className="app-address-text" style={{ fontFamily: "monospace" }}>
                                                        {start_and_end(item.trx_hash)}
                                                    </span>
                                                    <button
                                                        className="btn btn-sm btn-link text-warning p-0 ms-2"
                                                        onClick={() => handleCopy(item.trx_hash, `hash-${index}`)}
                                                        title="Copy Transaction Hash"
                                                    >
                                                        {copiedId === `hash-${index}` ? (
                                                            <i className="bi bi-check2 text-success"></i>
                                                        ) : (
                                                            <i className="bi bi-copy"></i>
                                                        )}
                                                    </button>
                                                </td>
                                                <td>
                                                    {item.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) : "N/A"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* Staking History Table */}
                    {/* <div className="app-table-container">
            <table className="app-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Amount</th>
                  <th>To Address</th>
                  <th>From Address</th>
                  <th>Trx Hash</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {stackingData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    <td>{item.amount} DEOD</td>

                    <td className="app-address-cell">
                      <span className="app-address-text">
                        {start_and_end(item.sender_address)}
                      </span>


                    </td>

                    <td className="app-address-cell">
                      <span className="app-address-text">
                        {start_and_end(item.recipient_address)}
                      </span>


                    </td>
                    <td className="app-address-cell">
                      <span className="app-address-text">
                        {start_and_end(item.trx_hash)}
                      </span>


                    </td>

                    <td>{item.createdAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div> */}
                </div>
            </UserPageSection>
        </div>
    );
};

export default UserstakeA;
